module.exports = "<app-aside-nav></app-aside-nav>\n\n<router-outlet></router-outlet>\n"